
import React from "react";
import "./RecurringCleaningService.css";

const RecurringCleaningService = () => {
  return (
    <div className="recurring-cleaning-container">
      <h1>Life gets busy. Let us keep your home clean.</h1>
      <p>
        That’s why we offer Recurring Cleaning services to keep your home fresh, tidy, and welcoming without the hassle.
        Whether you choose weekly, bi-weekly, or monthly visits, we provide reliable, top-quality cleaning that fits seamlessly into your lifestyle.
      </p>

      <h2>What’s Included:</h2>
      <p>
        Our regular visits help maintain a comfortable, clean space you’ll love coming home to. Each service typically includes:
      </p>
      <ul>
        <li>General dusting of surfaces, furniture, and décor</li>
        <li>Thorough vacuuming of all carpeted areas</li>
        <li>Sweeping and mopping of hard floors</li>
        <li>Kitchen surface cleaning and exterior appliance wipe-downs</li>
        <li>Bathroom sanitizing (toilets, sinks, mirrors, and counters)</li>
        <li>Emptying trash bins and replacing liners</li>
        <li>Tidying beds and straightening living spaces</li>
        <li>Wiping high-touch areas (like handles and light switches)</li>
      </ul>

      <h2>Why Choose Us for Recurring Cleaning?</h2>
      <ul>
        <li>🏠 <strong>Consistency You Can Count On</strong> – Enjoy a sparkling clean home week after week.</li>
        <li>📅 <strong>Customized to Your Schedule</strong> – Pick a frequency that works best for you.</li>
        <li>🧼 <strong>Thorough, Friendly, Reliable</strong> – The same trusted team, every time.</li>
        <li>💬 <strong>Easy Communication</strong> – Schedule changes? Just let us know, we’re flexible.</li>
        <li>🌟 <strong>Feel the Freshness, Always</strong> – Less mess. Less stress. More peace of mind.</li>
      </ul>
    </div>
  );
};

export default RecurringCleaningService;
